var Dto = /** @class */ (function () {
    function Dto() {
    }
    return Dto;
}());
export { Dto };
